import { useCallback } from "react";
import { useNavigate } from "react-router-dom";
import PropTypes from "prop-types";

const MainArea = ({ className = "" }) => {
  const navigate = useNavigate();

  const onHomeTextClick = useCallback(() => {
    navigate("/41-home");
  }, [navigate]);

  const onKhiNgGiGiClick = useCallback(() => {
    navigate("/41-history-5");
  }, [navigate]);

  const onChatGPTImage1329245ThgClick = useCallback(() => {
    navigate("/41-setting-wifi");
  }, [navigate]);

  return (
    <section
      className={`self-stretch flex flex-row items-start justify-start pt-0 px-10 pb-[53px] box-border max-w-full text-left text-base text-dark-text font-text-regular-lowercase ${className}`}
    >
      <div className="flex-1 flex flex-col items-start justify-start gap-[39.5px] max-w-full mq400:gap-5">
        <div
          className="relative font-medium text-light-text whitespace-pre-wrap cursor-pointer"
          onClick={onHomeTextClick}
        >{`<  Home`}</div>
        <div className="relative text-5xl font-semibold">Kết nối với GiGi</div>
        <div className="self-stretch flex flex-row items-start justify-start py-0 pl-0.5 pr-0 box-border max-w-full text-lg">
          <div className="flex-1 flex flex-row items-start justify-start flex-wrap content-start gap-[25px] max-w-full">
            <div className="flex flex-col items-start justify-start pt-1.5 px-0 pb-0">
              <div className="flex flex-col items-start justify-start gap-8">
                <div className="w-3 h-3 relative rounded-[50%] bg-light-pink z-[1]" />
                <div className="flex flex-row items-start justify-start pt-0 px-0 pb-[22px]">
                  <div className="h-3 w-3 relative rounded-[50%] bg-light-pink z-[1]" />
                </div>
                <div className="flex flex-row items-start justify-start pt-0 px-0 pb-[22px]">
                  <div className="h-3 w-3 relative rounded-[50%] bg-light-pink z-[1]" />
                </div>
                <div className="flex flex-row items-start justify-start pt-0 px-0 pb-[22px]">
                  <div className="h-3 w-3 relative rounded-[50%] bg-light-pink z-[1]" />
                </div>
                <div className="w-3 h-3 relative rounded-[50%] bg-light-pink z-[1]" />
              </div>
            </div>
            <div className="flex-1 flex flex-col items-start justify-start gap-[21px] min-w-[209px] max-w-full">
              <div className="self-stretch flex flex-row items-start justify-start py-0 pl-3 pr-0">
                <div
                  className="flex-1 relative leading-[120%] cursor-pointer"
                  onClick={onKhiNgGiGiClick}
                >
                  <p className="m-0">Khởi động GiGi</p>
                  <p className="m-0">&nbsp;</p>
                  <p className="m-0">
                    Lần đầu đăng ký, vui lòng đăng ký bằng email + pass.
                  </p>
                  <p className="m-0">&nbsp;</p>
                  <p className="m-0">
                    <span>Trên điện thoại, vào phần Wi-Fi và kết nối với mạng có tên bắt đầu bằng GiGi_...</span>
                  </p>
                  <p className="m-0">&nbsp;</p>
                  <p className="m-0">
                  Sau khi kết nối thành công, mở app và Nhập tên bé và năm sinh. Chọn mạng Wi-Fi gia đình và nhập mật khẩu Wi-Fi
                  </p>
                  <p className="m-0">&nbsp;</p>
                  <p className="m-0">Bấm Lưu. GiGi sẽ tự động kết nối Wi-Fi và sẵn sàng trò chuyện và học cùng bé mỗi ngày! "Lưu ý: Tên bé chỉ cần nhập một lần duy nhất. Wi-Fi chỉ cần cài lại nếu gia đình đổi mạng mới!"</p>
                </div>
              </div>
              <div className="flex flex-col items-end justify-start text-center text-sm text-light-text">
                <div className="flex flex-row items-start justify-end py-0 pl-0 pr-px">
                  <div className="flex flex-row items-start justify-start gap-[43px] mq330:gap-[21px]">
                    <img
                      className="w-[116px] relative max-h-full object-cover cursor-pointer"
                      loading="lazy"
                      alt=""
                      src="/chatgpt-image-13-29-24-5-thg-4-2025-1@2x.png"
                      onClick={onChatGPTImage1329245ThgClick}
                    />
                    <img
                      className="w-[116px] relative max-h-full object-cover z-[1]"
                      loading="lazy"
                      alt=""
                      src="/device-12-low-battery-1@2x.png"
                    />
                  </div>
                </div>
                <div className="w-[266px] flex flex-row items-start justify-between gap-5">
                  <div className="relative font-medium z-[1]">
                    Đã kết nối wifi
                  </div>
                  <div className="relative font-medium">Chưa kết nối wifi</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

MainArea.propTypes = {
  className: PropTypes.string,
};

export default MainArea;
